// extracted by mini-css-extract-plugin
export default {"cls1":"CreateComment-cls1__f521cbe4fa7214affefd","cls2":"CreateComment-cls2__e0f85a711f6805d6c194 CreateComment-cls1__f521cbe4fa7214affefd"};